module.exports = __webpack_public_path__ + "static/media/scraping.06489d94.pdf";